export default "__VITE_ASSET__BVJv5ZrX__"